import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useState } from "react";
import "./styles.scss";
import inovaLogo from "../../assets/inova@2x.png";
import api from "../../services/api";
import Cookies from "js-cookie";

function Login() {
  let navigate = useNavigate();
  const [values, setValues] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form values:", values);
    try {
      let {
        data: { token, idU, id, tipo },
      } = await api.post("/login2", values);
      console.log("API response:", { token, idU, id, tipo });
      Cookies.set("Inova", token);  
      Cookies.set("id", id);
      Cookies.set("clientID", idU);
      navigate("/PrincipalAdm");
      console.log("Navigation to /PrincipalAdm triggered");
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <div className="container-login">
      <div className="content-1">
        <img src={inovaLogo} style={{ width: "200px" }} alt="logo" />
        <p style={{ marginTop: "-30px" }}>ÁREA ADMINISTRATIVA</p>
        <div className="camp">
          <label className="text-gray">E-mail</label>
          <input type="text" name="email" onChange={(e) => handleChange(e)} />
        </div>

        <div className="camp last">
          <label className="text-gray">Senha</label>
          <input type="password" name="senha" onChange={(e) => handleChange(e)} />
        </div>

        <span>
          <Link to="/RecuperarSenha">
            <p className="text-blue">Esqueceu a senha?</p>
          </Link>
        </span>
        <button onClick={handleSubmit}>Entrar</button>
      </div>
    </div>
  );
}

export default Login;
